// Zeitraum der Berichte: Voreinstellungen (7 Tage … 1 Jahr) und zwei Datumsfelder. Der Zeitraum steht in der Adresse
// (?von=…&bis=…), so lässt sich ein Bericht verlinken und ein Neuladen ändert nichts. Der Server rechnet nach dem Einschreibedatum.
import { useSearchParams } from "react-router-dom";
import { heute, tagPlus, tageZwischen } from "../werkzeuge/zeit";
import { ZEITRAEUME } from "./teil2Hilfen";

export interface Zeitraum {
  von: string;
  bis: string;
}

export function useZeitraum(standardTage = 30): [Zeitraum, (z: Zeitraum) => void] {
  const [params, setParams] = useSearchParams();
  const ok = (s: string | null) => !!s && /^\d{4}-\d{2}-\d{2}$/.test(s);
  const bis = ok(params.get("bis")) ? (params.get("bis") as string) : heute();
  const von = ok(params.get("von")) ? (params.get("von") as string) : tagPlus(bis, -(standardTage - 1));
  const setzen = (z: Zeitraum) => {
    const n = new URLSearchParams(params);
    n.set("von", z.von);
    n.set("bis", z.bis);
    setParams(n, { replace: true });
  };
  return [{ von, bis }, setzen];
}

export function ZeitraumWahl({ zeitraum, onChange }: { zeitraum: Zeitraum; onChange: (z: Zeitraum) => void }) {
  const tage = tageZwischen(zeitraum.von, zeitraum.bis) + 1;
  const bisHeute = zeitraum.bis === heute();
  return (
    <div className="wf-zeitraum">
      <div className="segment" role="group" aria-label="Zeitraum">
        {ZEITRAEUME.map((z) => (
          <button
            key={z.tage}
            type="button"
            className={`segment__knopf${bisHeute && tage === z.tage ? " segment__knopf--an" : ""}`}
            onClick={() => onChange({ von: tagPlus(heute(), -(z.tage - 1)), bis: heute() })}
          >
            {z.label}
          </button>
        ))}
      </div>
      <span className="wf-inline">
        <input
          className="eingabe eingabe--datum"
          type="date"
          value={zeitraum.von}
          max={zeitraum.bis}
          aria-label="Eingeschrieben von"
          onChange={(e) => e.target.value && onChange({ von: e.target.value, bis: zeitraum.bis })}
        />
        <span className="leise">bis</span>
        <input
          className="eingabe eingabe--datum"
          type="date"
          value={zeitraum.bis}
          min={zeitraum.von}
          aria-label="Eingeschrieben bis"
          onChange={(e) => e.target.value && onChange({ von: zeitraum.von, bis: e.target.value })}
        />
      </span>
      <span className="leise wf-zeitraum__hinweis">nach Einschreibedatum</span>
    </div>
  );
}
